'use client';

import { motion } from 'framer-motion';
import { Calendar, ChevronRight, Zap } from 'lucide-react';
import { EASE_OUT, EASE_CUSTOM } from '@/lib/animations'
import { Button } from '@/components/ui/button';

export default function Cierre() {
    return (
        <section className="relative py-28 md:py-40 bg-slate-900 flex flex-col items-center justify-center overflow-hidden min-h-[70vh]">

            {/* Background glows */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[120px] pointer-events-none" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-indigo-500/10 rounded-full blur-[60px] pointer-events-none" />

            {/* Subtle grid */}
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMEw2MCAwTTAgMEwwIDYwIiBzdHJva2U9InJnYmEoMjU1LDI1NSwyNTUsMC4wMykiIHN0cm9rZS13aWR0aD0iMXB4IiBmaWxsPSJub25lIi8+PC9zdmc+')] opacity-40 pointer-events-none" />

            <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10 w-full">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-100px' }}
                    transition={{ duration: 1, ease: EASE_CUSTOM }}
                    className="flex flex-col items-center"
                >
                    {/* Status badge */}
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/[0.04] border border-white/[0.08] mb-10">
                        <span className="relative flex h-1.5 w-1.5">
                            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-blue-400 opacity-75" />
                            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-blue-500" />
                        </span>
                        <span className="font-mono text-[10px] tracking-widest text-neutral-400 uppercase">
                            Diagnósticos disponibles
                        </span>
                    </div>

                    {/* Headline */}
                    <h2 className="text-4xl sm:text-7xl md:text-8xl font-black tracking-tighter text-white mb-6 leading-[0.9]">
                        ¿Empezamos?
                    </h2>

                    <p className="text-neutral-400 max-w-lg mx-auto text-lg font-light leading-relaxed mb-12">
                        30 minutos para analizar tu negocio.
                        <br />
                        En 48h tienes un informe con lo que hay que cambiar.
                        Sin compromiso.
                    </p>

                    {/* CTA button — shadcn dark variant with gradient glow */}
                    <div className="relative group w-full max-w-md">
                        <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 via-indigo-500 to-blue-600 rounded-2xl blur-xl opacity-40 group-hover:opacity-70 transition-opacity duration-700" />
                        <Button
                            asChild
                            size="xl"
                            variant="dark"
                            className="relative w-full border border-white/10 [&_svg]:size-5 hover:bg-slate-800 hover:translate-y-0"
                        >
                            <a
                                href="https://calendly.com/innovatheratech/30min"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Calendar className="text-blue-400" />
                                Pedir mi diagnóstico gratuito
                                <ChevronRight className="text-blue-400/70 transition-transform group-hover:translate-x-1" />
                            </a>
                        </Button>
                    </div>

                    {/* Details */}
                    <div className="mt-8 flex flex-wrap items-center justify-center gap-3 sm:gap-4 text-[10px] sm:text-xs font-mono tracking-widest text-neutral-600 uppercase">
                        <span className="flex items-center gap-1.5">
                            <Zap className="w-3 h-3 text-blue-500/40" />
                            30 Minutos
                        </span>
                        <span className="w-1 h-1 rounded-full bg-neutral-800" />
                        <span>Google Meet</span>
                        <span className="w-1 h-1 rounded-full bg-neutral-800" />
                        <span>100% Confidencial</span>
                    </div>
                </motion.div>
            </div>

            <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/5 to-transparent" />
        </section>
    );
}
